<template>
<v-card flat color='grey lighten-4 mb-5'>
  <v-card-title class='subtitle-1 subheading' >
    {{member.practitioner_name}}
    <v-spacer></v-spacer>
    <v-chip color='success' dark small label >{{member.role}}</v-chip>
  </v-card-title>
  <v-divider></v-divider>
    <!-- <v-card-text>
      <v-checkbox
        label='Is Owner' v-model='isOwner'
        hint='Owners can perform all actions on a space' persistent-hint >
      </v-checkbox>
    </v-card-text> -->
  <v-alert dense text tile
    v-if="isOwner"
    border="left" type="info" >
    Owners can perform all actions
  </v-alert>
  <template v-else >
    <v-card-title >
      Manage permissions for this user
      <v-spacer/>
      <v-btn @click='getActions' :loading='requests.actions.loading' small icon ><v-icon>mdi-reload</v-icon></v-btn>
    </v-card-title>
    <v-alert dense text tile border="left" type='info' class='pa-1 caption' >
      Users have full control over all their own items.
      The permissions below refer to permissions across the team
    </v-alert>
    <request-status :request='requests.save' />
    <v-layout wrap >
      <v-flex xs12 sm12 md6 lg6 xl3 class="pa-2"
        v-for='(actionlist, category) in actions' :key='category' >
        <v-card height='100%' >
          <v-card-title class='overline' >
            {{category}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider />
          <v-card-title >
            <v-spacer/>
            <v-btn @click='selectAll(category)' small text >select all</v-btn>
            <v-btn @click='selectNone(category)' small text >select none</v-btn>
          </v-card-title>

          <v-list dense :key='category' >
            <template v-for='action in actionlist' >
              <v-list-item :key='action.id' >
                <v-list-item-action >
                  <!-- :readonly='action.required'
                  :disabled='action.required' -->
                  <v-checkbox dense hide-details
                    v-model='selectedActions'
                    class='ma-0'
                    :value='action.id' />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title >
                    {{action.title}}
                    <v-chip x-small label outlined v-if='action.required' >required</v-chip>
                    <v-chip x-small label outlined v-if='action.id' class="ml-2" >{{action.id}}</v-chip>
                    <!-- ({{action.id}}) -->
                  </v-list-item-title>
                  <v-list-item-subtitle >
                    {{action.description}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key='`div-${action.id}`' />
            </template>
          </v-list>

          <v-card-actions class='mt-4'>
            <v-spacer></v-spacer>
            <v-btn
              @click='save' :loading='requests.save.loading'
              color="primary" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </template>

</v-card>
</template>
<script>
import Vue from 'vue'

export default {
  name: 'PermissionsPicker',
  props: {
    spaceId: { required: true },
    memberId: { required: true },
    value: { type: Object, required: false },
    title: { type: String, required: false }
  },
  data () {
    return {
      selectedActions: [],
      member: {},
      // isOwner: false,
      requests: {
        get: {
          resource: 'ag.spaces.members',
          kwargs: {spaceId: this.spaceId},
          result: {}
        },
        save: {
          resource: 'ag.spaces.practitioner',
          kwargs: {spaceId: this.spaceId},
          result: {},
          method: 'post',
          extra: 'actions/set_permissions'
        },
        actions: {
          resource: 'ag.actions'
        }
      }
    }
  },
  mounted () {
    Vue.set(this.requests.get, 'kwargs', {spaceId: this.spaceId})
    Vue.set(this.requests.save, 'kwargs', {spaceId: this.spaceId})
    this.getActions()
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.member = this.value }
        let actions = this.getObjectPath(this.member, 'enabled_actions', [])
        this.selectedActions = actions
      }
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        this.$emit('input', this.requests.save.result)
        this.$emit('saved', this.requests.save.result)
      }
    }
  },
  computed: {
    actions () {
      return this.getObjectPath(this.requests.actions, 'result', {})
    },
    isOwner () {
      if (this.member && this.member.role === 'Owner') { return true }
      return false
    },
    saveRequestStatus () {
      return this.requests.save.status
    }
  },
  methods: {
    getMember () {
      if (this.memberId) {
        this.resourceId = this.memberId
        this.$request('get', this.requests.get)
      }
    },
    save () {
      if (this.memberId) {
        Vue.set(this.requests.save, 'resourceId', this.spaceId)
        this.requests.save.data = {
          permissions: this.selectedActions.join(','),
          member: this.memberId
        }
        this.$request('save', this.requests.save)
      }
    },
    getActions () {
      this.requests.actions.params = { a: Math.random().toString() }
      this.$request('get', this.requests.actions)
    },
    getItemIndex (item, items) {
      return items.findIndex((action) => {
        return action === item.id
      })
    },
    selectAll (category) {
      let items = this.actions[category]
      if (items) {
        items.forEach((item) => {
          let index = this.getItemIndex(item, this.selectedActions)
          let exists = index > -1
          if (!exists) {
            this.selectedActions.push(item.id)
          }
        })
      }
    },
    selectNone (category) {
      let items = this.actions[category]
      if (items) {
        items.forEach((item) => {
          let index = this.getItemIndex(item, this.selectedActions)
          let exists = index > -1
          if (exists) {
            this.selectedActions.splice(index, 1)
          }
        })
      }
    }
  }
}
</script>
